import React, { useEffect, useState } from "react";
import LoginErrMsg from "../../../login/generic/loginErrMsg";
import InputField from "../../../generic/inputField";
import EdButton from "../../../generic/edButton";
import { emailRegex } from "../../../utils/regex";
import { useHistory } from "react-router-dom";
import { RoutesUrl } from "../../../../Containers/Routes/constents";

export interface VForgotPasswordFormProps {
  disableForm: boolean; // used to disable/enable form from parent
  errorMsg?: string; // error message that came from api
  email: string; // email address
  setEmail: (val: string) => void; // set email address
  onSubmit: () => void; // function to be called on submit
  onRemoveError: () => void; // removes the errorMsg
}

const ForgotPasswordForm: React.FC<VForgotPasswordFormProps> = (props) => {
  const [userNameErr, setUserNameErr] = useState<string>("");
  const history = useHistory();

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    props.onSubmit();
  };

  useEffect(() => {
    if (props.errorMsg) {
      props.onRemoveError();
    }
  }, [props.email]);

  return (
    <div className="login_form loginid_form">
      <form onSubmit={handleSubmit} className="mg-b60">
        <div className="forgotPassword_head">
          <h3>Forgot Password</h3>
          <p>
            Please enter you registered email and we will send you the OTP and
            instruction to reset password
          </p>
        </div>
        <label htmlFor="userID" className="inp_lbl mg-b5 ib">Email ID</label>
        <InputField
          id="userID"
          pattern={emailRegex}
          defaultValue={props.email}
          onChange={(value) => props.setEmail(value)}
          onBlur={(error) => {
            setUserNameErr(error.pattern ? "" : "Please enter a valid email");
          }}
          className="login_inp mg-b40"
          placeholder="Eg: example@email.com"
          autoComplete="off"
          errorText={userNameErr}
        />

        {/* Show error if any */}
        {props.errorMsg && (
          <LoginErrMsg className="mg-b40">{props.errorMsg}</LoginErrMsg>
        )}

        {/* Disable button if username or password is blank or form is disabled from outside */}
        <EdButton
          value="Send OTP"
          btnTyp="primary"
          className="submit_btn"
          disabled={props.disableForm || !props.email || userNameErr !== ""}
        />
      </form>

      <div className="login_frm_btm_txt">
        <p>
          Landed Here by mistake?{" "}
          <EdButton
            value="Go to Login"
            btnTyp="blue-link"
            className="link_btn"
            onClick={() => history.push(RoutesUrl.VendorLogin)}
          />
        </p>
      </div>
    </div>
  );
};

export default ForgotPasswordForm;
